import api from '../../api/_auth'
import apiConfig from '../../api/config/_user'
import { setToken } from "../../utils/utils-mixins";

const state = () => ({
   authInfo: null,
   activeRole: null,

   auth_user: []
})

// getters
const getters = {
    authInfo: (state) =>{
        return state.authInfo
    },

    activeRole: (state) =>{
        return state.activeRole
    },

    auth_user: (state) =>{
        return state.auth_user
    },
}

// mutations
const mutations = {
    SET_CREDENTIALS(state, authInfo) {
        state.authInfo = authInfo;
    },

    SET_ACTIVE_ROLE(state, activeRole){
        state.activeRole = activeRole
    },

    SET_AUTH_USER(state, auth_user){
        state.auth_user = auth_user
    }
}

// actions
const actions = {

    login({commit},data){
        return new Promise((resolve, reject) =>{
            api.login(data).then(
                response => {
                    let res = {
                        access_token: response.access_token,
                        expires_in: response.expires_in,
                        token_type: response.token_type,
                        // PORT-001 : début de session du poste (expiration à 12 h pour l'agent de sécurité).
                        logged_at: Date.now(),
                        user: {
                            can_login: response.can_login,
                            id: response.id,
                            name: response.name,
                            email: response.email,
                            roles: response.roles,
                            titre: response.titre
                        }
                    }
                    commit('SET_CREDENTIALS', res)
                    setToken(res.access_token);
                    
                    resolve(res)
                    let index = 0
                    let roleToUse = null;
                    let defaultRole = null;
                    for(index =0; index<res.user.roles.length;index++)
                    {
                         if(res.user.roles[index].pivot.is_active === 1 || res.user.roles[index].pivot.is_active === '1' || res.user.roles[index].pivot.is_active === true)
                         {
                            roleToUse = res.user.roles[index];
                            commit('SET_ACTIVE_ROLE',roleToUse)
                         }
                         if(res.user.roles[index].pivot.is_default === 1 || res.user.roles[index].pivot.is_default === '1' || res.user.roles[index].pivot.is_default === true )
                         {
                            defaultRole = res.user.roles[index];
                            
                         } 
                        
                    }
                    if(roleToUse === null)
                    {
                        roleToUse = commit('SET_ACTIVE_ROLE',roleToUse);
                    }
                    console.log(defaultRole)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    // login({commit},data){
    //     return new Promise((resolve, reject) =>{
    //         api.login(data).then(
    //             response => {
    //                 commit('SET_CREDENTIALS',response)
    //                 resolve(response)
    //                 console.log(response)
    //             }, error => {
    //                 console.log("-->>ERROR LOGIN ",error)
    //                 reject(error);
    //             }
    //         )
    //     })
    // },

    switchRole({commit},{userId,roleId}){
        return new Promise( (resolve,reject) =>{
            apiConfig.updateActiveRole(userId,roleId).then(
                response => {
                    resolve(response)
                    commit('SET_ACTIVE_ROLE',response)

                },error =>{
                    reject(error)
                }
            )
        })
    },

    getAuthUser({commit}, {user_id}) {
        return new Promise((resolve, reject) => {
            apiConfig.getAuthUser(user_id).then(
                response => {
                    resolve(response)
                    commit('SET_AUTH_USER', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}